/* global $ */

import React, { Component } from 'react';
import {tooltipDateFormat} from '../../lib/analytics.js';

export class NewVsReturningUsers extends Component {

    constructor(props) {
        super(props);
        this.chart = undefined;
    }

    componentDidMount() {
        var self = this;
        this.chart = $(this.refs.newVsReturningUsers).highcharts({
            colors: ['#3399CC', '#0073CF'],
            chart: {
                type: 'column',
                height: '320px'
            },
            title: {
                text: null
            },
            xAxis: {
                type: 'datetime',
                lineWidth: 0,
                tickLength: 0
            },
            yAxis: {
                min: 0,
                title: {
                    text: null
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                formatter: function() {
                    var s = [];
                    s.push(tooltipDateFormat(this.x, self.props.timePeriod, self.props.lang));

                    $.each(this.points, function(i, point) {
                        s.push('<br/><span style="fill:'+point.series.color+'" x="8" dy="16">'+
                            point.series.name + '</span>'+'<span><span dx="0">: </span>' +
                            '<b>' + point.y + '</b>');
                    });

                    return s.join('<br />');
                },
                shared: true
            },
            credits: {
                enabled: false
            },
            series: [
                {
                    name: this.props.showMessage('message_21_01'),
                    data: this.props.data.new
                },
                {
                    name: this.props.showMessage('message_21_02'),
                    data: this.props.data.returning
                }
            ]
        });
        this.updateChart();
    }

    componentWillReceiveProps(props) {
        this.chart.highcharts().series[0].setData(props.data.new, true);
        this.chart.highcharts().series[1].setData(props.data.returning, true);
    }

    componentDidUpdate() {
        this.updateChart();
    }

    updateChart() {
        this.chart.highcharts().series[0].update({name: this.props.showMessage('message_21_01')});
        this.chart.highcharts().series[1].update({name: this.props.showMessage('message_21_02')});
    }

    render() {
        return (
            <div ref='newVsReturningUsers'>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/NewVsReturningUsers.jsx